<template>
  <div>
    <general-error v-if="!!generalError" />
    <v-progress-linear :active="isLoading" color="loader" indeterminate />
    <v-row justify="end">
      <v-col v-html="content" />
      <v-col v-if="isAdmin" cols="2" class="text-right pa-4">
        <route-btn-tip
            :id="pageTag"
            icon="edit"
            :tip="$t('Редактировать содержимое')"
            :disabled="isLoading"
            :to="{ path: `${urlRootPath}/staticPage/${tag}` }" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import RouteBtnTip from '@/components/reused/ui/RouteBtnTip.vue'
  import { mapActions, mapState } from 'vuex'
  import { STATIC_PAGES } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      RouteBtnTip
    },
    props: {
      pageTag: {
        type: String
      }
    },
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      ...mapState(STATIC_PAGES.NAMESPACE, {
        pages: state => (state[STATIC_PAGES.STATE.CURRENT_STATIC_PAGE_CONTENT] || {})
      }),
      content () {
        return this.pages[this.tag]
      },
      tag () {
        return `${this.pageTag}_${this.systemLocale.toLowerCase()}`
      }
    },
    beforeDestroy () {
      this.clearStore()
    },
    created: function () {
      const vm = this
      vm.clearStore().then(() => {
        if (vm.pageTag) {
          vm.getPublishedPageContent()
        }
      })
    },
    methods: {
      ...mapActions(STATIC_PAGES.NAMESPACE, {
        getPublishedPageContentAction: STATIC_PAGES.ACTIONS.GET_PUBLISHED_PAGE_CONTENT,
        clearPublishedPageContentAction: STATIC_PAGES.ACTIONS.CLEAR_PUBLISHED_PAGE_CONTENT
      }),
      clearStore: async function () {
        await Promise.all(
          [
            this.clearPublishedPageContentAction()
          ])
      },
      getPublishedPageContent: async function () {
        try {
          this.isLoading = true
          await this.getPublishedPageContentAction({
            tag: this.tag
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      }
    }
  }
</script>
